import React from "react";

const RaindropTextSubtitle = ({
  isCentered = false,
  children,
  className = "",
}) => {
  let tailwindTextAlignment = "text-left";

  if (isCentered) {
    tailwindTextAlignment = "text-center";
  }
  return (
    <div
      className={` text-md font-semibold text-color-text-secondary dark:text-color-dark-text-secondary ${tailwindTextAlignment} ${className}`}
    >
      {children}
    </div>
  );
};

export default RaindropTextSubtitle;
